import deepmerge from 'deepmerge';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

export const merge = <T extends unknown>(
    one: RecursivePartial<T>,
    two: RecursivePartial<T>,
    options?: deepmerge.Options
): T => deepmerge<T>(one as Partial<T>, two as Partial<T>, options);
